import { groupBy } from "lodash-es";
import { ensureDate } from "../support/dates";
import { Status, type Statused } from "../types";

export const statusOrder: Array<Status> = [
  Status.ACTIVE,
  Status.INACTIVE,
  Status.ON_HOLD,
  Status.OUT_LATE,
  Status.CLOSED_TEMPORARILY,
  Status.CLOSED_SEASONALLY,
  Status.CLOSED_PERMANENTLY
];

export function isStatusOverriden(subject: Statused, now: Date): boolean {
  if (subject.overrideStatus && subject.overrideStatusExpiration) {
    return ensureDate(subject.overrideStatusExpiration) > ensureDate(now);
  }

  return false;
}

export function getStatus(subject: Statused, now: Date): Status {
  if (isStatusOverriden(subject, now)) {
    return subject.overrideStatus as Status;
  }

  return subject.canonicalStatus;
}

export function getStatusNote(subject: Statused, now: Date): string | null {
  if (isStatusOverriden(subject, now)) {
    return subject.overrideStatusNote;
  }

  return subject.canonicalStatusNote;
}

export function groupByStatus(subjects: Array<Statused>, now: Date) {
  return groupBy(subjects, (subject) => {
    return getStatus(subject, now);
  });
}

/**
 * Indicates if the status should be displayed in the UI
 */
export function isDisplayedStatus(status: Status): boolean {
  return status !== Status.INACTIVE;
}

export function isDisplayed(subject: Statused, now: Date): boolean {
  const status = getStatus(subject, now);

  return isDisplayedStatus(status);
}

export function isClosedStatus(status: Status): boolean {
  return status != Status.ACTIVE;
}

export function getClosed(subject: Statused, now: Date): boolean {
  const status = getStatus(subject, now);

  return isClosedStatus(status);
}
